import { createSelector } from '@reduxjs/toolkit';
import { HyperVDogfoodingProjectUrisMap } from '../../../constants/add-ons';
import { getTokensFromDevBoxDataPlaneUri } from '../../../ids/dev-box';
import { createProjectDataPlaneUri } from '../../../ids/project';
import { some } from '../../../utilities/serializable-map';
import { areStringsEquivalent } from '../../../utilities/string';
import { getDevBoxes } from '../../selector/dev-box-selectors';

/**
 * Application state selectors
 */

// For now, get add ons only for those dev boxes that are in the dogfooding pool
export const getIdsForDevBoxesRequiringDevBoxAddOns = createSelector([getDevBoxes], (devBoxes) =>
    devBoxes
        .filter((devBox) => {
            const { devCenter, projectName } = getTokensFromDevBoxDataPlaneUri(devBox.uri);
            const projectUri = createProjectDataPlaneUri({ devCenter, projectName });
            return some(HyperVDogfoodingProjectUrisMap, (_, uri) => areStringsEquivalent(projectUri, uri, true));
        })
        .map((devBox) => devBox.uri)
);
